import { ReactNode, ButtonHTMLAttributes } from "react";

interface OutlineButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon?: ReactNode;
  label: string;
}

export const OutlineButton = ({
  icon,
  label,
  className,
  ...buttonProps
}: OutlineButtonProps) => {
  return (
    <button
      {...buttonProps}
      className={`flex justify-center items-center gap-2 px-4 py-[0.565rem] w-40 bg-transparent border border-[rgba(208,213,221,1)] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] rounded-sm transition-colors hover:bg-[rgba(208,213,221,0.1)] disabled:opacity-60 ${className || ''}`}
    >
      {icon}
      <span className="text-base text-[rgba(52,64,84,1)] text-medium">
        {label}
      </span>
    </button>
  );
};
